/**
 * SummaryStatCard — horizontal metric card (label, value, optional trailing, decorative icon).
 */
import { Card } from "../../atoms/Card";
import { Typography } from "../../atoms/Typography";
import { IconWrapper } from "../../atoms/IconWrapper";
import { cn } from "@/utils/cn";
import type { SummaryStatCardProps } from "./SummaryStatCard.types";
import {
  summaryStatCardBodyClass,
  summaryStatCardIconShellClass,
  summaryStatCardTrailingRowClass,
} from "./SummaryStatCard.styles";

export type { SummaryStatCardProps } from "./SummaryStatCard.types";

export function SummaryStatCard({
  label,
  value,
  icon,
  trailing,
  className,
}: SummaryStatCardProps) {
  return (
    <Card
      variant="custom"
      padding="md"
      rounded="xl"
      className={cn(
        "flex items-center justify-between border border-light-lin",
        className
      )}
    >
      <div className={summaryStatCardBodyClass}>
        <Typography
          variant="body-sm"
          weight="semibold"
          color="secondary"
          className="uppercase tracking-wide"
        >
          {label}
        </Typography>
        <Typography variant="h2" weight="bold" color="primary">
          {value}
        </Typography>
      </div>
      <div className={summaryStatCardTrailingRowClass}>
        {trailing}
        <div className={summaryStatCardIconShellClass}>
          <IconWrapper size="md" color="purple">
            {icon}
          </IconWrapper>
        </div>
      </div>
    </Card>
  );
}
